// TYPO3 liefert datetime als String, die Fractal-Fixture als Zahl.
type RawDateEntry = {
  datetime: number | string;
  title: string;
  meetingId: string;
  meetingCode: string;
  meetingLink: string;
};
type DateEntry = Omit<RawDateEntry, 'datetime'> & {
  datetime: number;
  formatted: string;
};

const formatDate = (ts: number): string => {
  const d = new Date(ts * 1000);
  const date = new Intl.DateTimeFormat('de-DE', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    timeZone: 'Europe/Berlin',
  }).format(d);
  const hour =
    new Intl.DateTimeFormat('de-DE', {
      hour: 'numeric',
      hourCycle: 'h23',
      timeZone: 'Europe/Berlin',
    })
      .formatToParts(d)
      .find((p) => p.type === 'hour')?.value ?? '';
  return `${date} | ${hour}Uhr`;
};

export const groupMentoringDates = () => ({
  upcomingDates: [] as DateEntry[],
  pastDates: [] as DateEntry[],

  init() {
    const raw: RawDateEntry[] = JSON.parse(
      (this.$el as HTMLElement).dataset.dates ?? '[]'
    );
    const now = Date.now() / 1000;

    const enriched = raw.map((e) => {
      const datetime = Number(e.datetime);
      return { ...e, datetime, formatted: formatDate(datetime) };
    });

    this.upcomingDates = enriched
      .filter((e) => e.datetime >= now)
      .sort((a, b) => a.datetime - b.datetime);

    this.pastDates = enriched
      .filter((e) => e.datetime < now)
      .sort((a, b) => b.datetime - a.datetime);
  },
});
